<div class="common-table-style">
<div class="header-box">
  <div class="d-flex align-items-center heading-box">
    <ng-icon name="heroClipboardDocumentCheck" ></ng-icon>
    <div>
        <h2>Reports
        </h2>    
    </div>
  </div>
</div>
<div class="inner-box">
 <div class="col-md-12">
    <div class="dashboard">
      <div class="row">
        <div class="col-md-3" >
          <mat-card class="statusBox " (click)="getContractsCommanly(0)" [ngClass]="{ 'active-tile': ActiveTileIndication === 0 }">
            <mat-card-content >
             <a href="javascript:void(0)" class="gray-txt" > All Agreements Pending Approval</a>
    
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-3" >
          <mat-card class="statusBox" (click)="getContractsCommanly(1)" [ngClass]="{ 'active-tile': ActiveTileIndication === 1 }">
            <mat-card-content >
             <a href="javascript:void(0)" class="gray-txt" > All Agreements Pending Review</a>

            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-3">
          <mat-card class="statusBox" (click)="getContractsCommanly(2)" [ngClass]="{ 'active-tile': ActiveTileIndication === 2 }">
            <mat-card-content >
             
             <a href="javascript:void(0)" class="gray-txt" >Agreement Turnaround Time</a> 
             
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-3">
          <mat-card class="statusBox" [class.disabled-tile]="disableTile"  (click)="getContractsCommanly(3)" [ngClass]="{ 'active-tile': ActiveTileIndication === 3 }">
            <mat-card-content >
            
            <a href="javascript:void(0)" class="gray-txt">  User Login Report</a>

            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <mat-card class="statusBox"[ngClass]="{ 'active-tile': ActiveTileIndication === 4 }" (click)="getContractsCommanly(4)">
            <mat-card-content >
             
              <a href="javascript:void(0)" class="gray-txt">All Agreement Stagnant for 5+ days</a>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-3">
          <mat-card class="statusBox" (click)="getContractsCommanly(5)" [ngClass]="{ 'active-tile': ActiveTileIndication === 5 }">
            <mat-card-content >
             
            <a href="javascript:void(0)" class="gray-txt" >All Expired Agreements</a>  

            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-3">
          <mat-card class="statusBox" [class.disabled-tile]="disableTile"  (click)="getContractsCommanly(6)" [ngClass]="{ 'active-tile': ActiveTileIndication === 6 }">
            <mat-card-content >
            <a href="javascript:void(0)" class="gray-txt">  All Obligations Overdue</a>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-3">
          <mat-card (click)="getContractsCommanly(7)" class="statusBox" [class.disabled-tile]="disableTile" [ngClass]="{ 'active-tile': ActiveTileIndication === 7 }">
            <mat-card-content >
            
            <a href="javascript:void(0)" class="gray-txt" >  All Terminated Agreements</a>

            </mat-card-content>
          </mat-card>
        </div>
      </div>
   
    

    </div>
  </div>
      <!-- Table for ActiveTileIndication 4 -->
<div class="inner-box">
      <p-table #dt1 *ngIf="ActiveTileIndication==4" 
      [paginator]="true" [rows]="6" [rowsPerPageOptions]="[1, 5, 10]"
      [alwaysShowPaginator]="false" 
      [columns]="selectedColumns" [value]="stagnant"
      [tableStyle]="{'min-width': '50rem'}" 
      [globalFilterFields]="['contractName', 'contractType', 'contractStatus', 'partyName', 'startDate', 'lastUpdatedDate', 'totalAgreementValue']"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[1, 5, 10]">
      <ng-template pTemplate="caption">
          <div class="row">
            <div class="mr-2 record">
              Total Records  {{dt1.totalRecords}}
              </div>
            <div class="col-md-3 ml-2"  >
              <div class="input-group">
                  <div class="input-group-prepend">
                      <span class="input-group-text"><i class="pi pi-search"></i></span>
                  </div>
                  <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')" class="form-control" placeholder="Columns Search" />
              </div> 
          </div>
                <div class="selectedColumns mr-2" >
                  <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
                      selectedItemsLabel="{0} columns selected" [style]="{'min-width': '200px'}" placeholder="Choose Columns"></p-multiSelect>
                </div>
              <div class="excel">
                <i  (click)="exportStagnantContracts()" class="mr-2 pi pi-file-excel"  style="font-size: 1.5rem; color: green;"></i>
              </div>
          </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" class="dataTable">
            <div>
              {{col.header}}
              <ng-container *ngIf="col.field !== 'createdDate' && col.field !== 'updateDate'; else dateFilter">
                <p-columnFilter type="text" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
              </ng-container>
              <ng-template #dateFilter>
                <p-columnFilter type="text" field="{{col.field}}" display="menu" class="ml-auto">
                  <input type="text" class="form-control" (input)="applyFilters()" placeholder="Search {{col.header}} (YYYY-MM-DD)" />
                </p-columnFilter>
              </ng-template>
              <ng-template #filterIcon>
                <i class="pi pi-filter" style="cursor: pointer;" (click)="showFilterInput(col.field)"></i>
              </ng-template>
            </div>
            <input *ngIf="showInput === col.field" pInputText type="text" [(ngModel)]="filters[col.field]" (input)="applyFilters()" class="form-control" placeholder="Search {{col.header}}" />
          </th>
        </tr>
      </ng-template>
      
    
    
    
    
      <ng-template pTemplate="body" let-product let-columns="columns"  let-rowIndex="rowIndex">
          <tr [ngClass]="{'even-row': rowIndex % 2 === 0, 'odd-row': rowIndex % 2 !== 0}">
              <ng-container *ngFor="let col of columns">
                  <td *ngIf="col.field === 'contractName'">
                      <a [routerLink]="['/app/contract', 'view', product.id]">{{product[col.field]}}</a>
                  </td>
                  <td *ngIf="col.field!== 'contractName'">
                      {{product[col.field]}}
                  </td>
              </ng-container>
          </tr>
      </ng-template>
  </p-table>
  
      
      <!-- Table for ActiveTileIndication 5 -->
      <p-table #dt2 *ngIf="ActiveTileIndication==5" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20]" [alwaysShowPaginator]="false" [columns]="selectedExpColumns" [value]="expried" [tableStyle]="{'min-width': '50rem'}"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [ngClassEven]="'even-row'"
      [ngClassOdd]="'odd-row'"
      [globalFilterFields]="['name', 'startDate', 'expiryDate', 'partyName','contractAmount']" [reorderableColumns]="true">
          <ng-template pTemplate="caption">

            <div class="row">
              <div class="mr-2 record">
                Total Record {{dt2.totalRecords}}
               </div>
               
              <div class="col-md-3 ml-3"  >
                <div class="input-group">
                    <div class="input-group-prepend">
                     
                        <span class="input-group-text"><i class="pi pi-search"></i></span>
                    </div>
                    <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value, 'contains')" class="form-control" placeholder="Columns Search" />
                </div>
            </div>
            <div class="selectedColumns mr-2">
              <p-multiSelect [options]="expire" [(ngModel)]="selectedExpColumns" optionLabel="header"
                  selectedItemsLabel="{0} columns selected" [style]="{'min-width': '200px'}" placeholder="Choose Columns"></p-multiSelect>
                </div>
        
                <div class="excel">
                  <i (click)="exportExpiredContracts()" class="mr-2 pi pi-file-excel"  style="font-size: 1.5rem; color: green;"></i>
                </div>
              </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
              <!-- <tr>
                  <th *ngFor="let col of columns">
                      {{col.header}}
                  </th>
                  
              </tr> -->
              <tr>
                <th *ngFor="let col of columns" class="dataTable">
                  <div>
                    {{col.header}}
                    <ng-container *ngIf="col.field !== 'startDate' && col.field !== 'expiryDate'; else dateFilter">
                        <p-columnFilter type="text" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
                    </ng-container>
                    <ng-template #dateFilter>
                        <p-columnFilter type="date" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
                    </ng-template>
                    <ng-template #filterIcon>
                        <i class="pi pi-filter" style="cursor: pointer;" (click)="showFilterInput(col.field)"></i>
                    </ng-template>
                </div>
                    <input *ngIf="showInput === col.field" pInputText type="text" [(ngModel)]="filters[col.field]" (input)="applyFilters()" class="form-control" placeholder="Search {{col.header}}" />
                </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-columns="columns" let-rowIndex="rowIndex">
              <tr [ngClass]="{'even-row': rowIndex % 2 === 0, 'odd-row': rowIndex % 2 !== 0}">
                  <ng-container *ngFor="let col of columns">
                      <td *ngIf="col.field === 'name'">
                          <a [routerLink]="['/app/contract', 'view', product.id]">{{product[col.field]}}</a>
                      </td>
                      <td *ngIf="col.field !== 'name'">
                          {{product[col.field]}}
                      </td>
                  </ng-container>
              </tr>
          </ng-template>
      </p-table>
  <!-- Table for ActiveTileIndication 0 -->
      <p-table #dt3 *ngIf="ActiveTileIndication==0" [paginator]="true" [rows]="6" [rowsPerPageOptions]="[5, 10, 20]" [alwaysShowPaginator]="false" [columns]="selectedApprove" [value]="pendingApprove" [tableStyle]="{'min-width': '50rem'}"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    
      [globalFilterFields]="['name', 'startDate', 'expiryDate', 'partyName','contractAmount']" [reorderableColumns]="true">
          <ng-template pTemplate="caption">
            <div class="row">
              <div class="mr-2 record">
                Total Record {{dt3.totalRecords}}
               </div>
              <div class="col-md-3 ml-3">
                <div class="input-group">
                    <div class="input-group-prepend">
                 
                        <span class="input-group-text"><i class="pi pi-search"></i></span>
                    </div>
                    <input pInputText type="text" (input)="dt3.filterGlobal($event.target.value, 'contains')" class="form-control" placeholder="Columns Search" />
                </div>
            </div>
            <div class="selectedColumns mr-2" >
              <p-multiSelect [options]="pendingApp" [(ngModel)]="selectedApprove" optionLabel="header"
                  selectedItemsLabel="{0} columns selected" [style]="{'min-width': '200px'}" placeholder="Choose Columns"></p-multiSelect>
                </div>
        
                <div class="excel">
                  <i  (click)="exportPendingApproval()" class="mr-2 pi pi-file-excel"  style="font-size: 1.5rem; color: green;"></i>
                </div>
              </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" class="dataTable">
                  <div>
                    {{col.header}}
                    <ng-container *ngIf="col.field !== 'createdDate' && col.field !== 'updatedDate'; else dateFilter">
                        <p-columnFilter type="text" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
                    </ng-container>
                    <ng-template #dateFilter>
                        <p-columnFilter type="date" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
                    </ng-template>
                    <ng-template #filterIcon>
                        <i class="pi pi-filter" style="cursor: pointer;" (click)="showFilterInput(col.field)"></i>
                    </ng-template>
                </div>
                    <input *ngIf="showInput === col.field" pInputText type="text" [(ngModel)]="filters[col.field]" (input)="applyFilters()" class="form-control" placeholder="Search {{col.header}}" />
                </th>
            </tr>
        </ng-template>
          <ng-template pTemplate="body" let-product let-columns="columns"  let-rowIndex="rowIndex">
          
              <tr [ngClass]="{'even-row': rowIndex % 2 === 0, 'odd-row': rowIndex % 2 !== 0}">
                  <ng-container *ngFor="let col of columns">
                      <td *ngIf="col.field === 'name'">
                          <a [routerLink]="['/app/contract', 'view', product.contractId]">{{product[col.field]}}</a>
                      </td>
                      <td *ngIf="col.field !== 'name'">
                          {{product[col.field]}}
                      </td>
                  </ng-container>
              </tr>
          </ng-template>
      </p-table>
      <p-table #dt4 *ngIf="ActiveTileIndication==1" [paginator]="true" [rows]="6" [rowsPerPageOptions]="[5, 10, 20]" [alwaysShowPaginator]="false" [columns]="selectedReview" [value]="pendingReview" [tableStyle]="{'min-width': '50rem'}"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    
      [globalFilterFields]="['name', 'startDate', 'expiryDate', 'partyName','contractAmount']" [reorderableColumns]="true">
          <ng-template pTemplate="caption">
            <div class="row">
              <div class="mr-2 record">
                Total Record {{dt4.totalRecords}}
               </div>
              <div class="col-md-3 ml-3">
                <div class="input-group">
                    <div class="input-group-prepend">
                   
                        <span class="input-group-text"><i class="pi pi-search"></i></span>
                    </div>
                    <input pInputText type="text" (input)="dt4.filterGlobal($event.target.value, 'contains')" class="form-control" placeholder="Columns Search" />
                </div>
            </div>
            <div class="selectedColumns mr-2">
              <p-multiSelect [options]="pendingReviews" [(ngModel)]="selectedReview" optionLabel="header"
                  selectedItemsLabel="{0} columns selected" [style]="{'min-width': '200px'}" placeholder="Choose Columns"></p-multiSelect>
                </div>
        
                <div class="excel">
                  <i  (click)="exportPendingReview()" class="mr-2 pi pi-file-excel"  style="font-size: 1.5rem; color: green;"></i>
                </div>
              </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" class="dataTable">
                  <div>
                    {{col.header}}
                    <ng-container *ngIf="col.field !== 'createdDate' && col.field !== 'updatedDate'; else dateFilter">
                        <p-columnFilter type="text" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
                    </ng-container>
                    <ng-template #dateFilter>
                        <p-columnFilter type="date" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
                    </ng-template>
                    <ng-template #filterIcon>
                        <i class="pi pi-filter" style="cursor: pointer;" (click)="showFilterInput(col.field)"></i>
                    </ng-template>
                </div>
                    <input *ngIf="showInput === col.field" pInputText type="text" [(ngModel)]="filters[col.field]" (input)="applyFilters()" class="form-control" placeholder="Search {{col.header}}" />
                </th>
            </tr>
        </ng-template>
          <ng-template pTemplate="body" let-product let-columns="columns" let-rowIndex="rowIndex">
              <tr [ngClass]="{'even-row': rowIndex % 2 === 0, 'odd-row': rowIndex % 2 !== 0}">
                  <ng-container *ngFor="let col of columns">
                      <td *ngIf="col.field === 'name'">
                          <a [routerLink]="['/app/contract', 'view', product.contractId]">{{product[col.field]}}</a>
                      </td>
                      <td *ngIf="col.field !== 'name'">
                          {{product[col.field]}}
                      </td>
                  </ng-container>
              </tr>
          </ng-template>
      </p-table>

</div>
  
<div class="task-graph  "*ngIf="ActiveTileIndication==2" >
  <app-report-chart></app-report-chart>
</div>
</div>